export default __webpack_public_path__ + "static/media/base_station_icon.85d6a6e0.svg";